import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchEnergyBudget } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const interval = 'month';
const ChartEnergyBudgetForecast = ({ type, id }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const showData = async (_data) => {
    const arrData = [];
    const energyBudget = [];
    const energyConsumption = [];
    let accumulatedEnergyBudget = 0;
    let accumulatedEnergyConsumption = 0;
    let forecastStartIndex = 0;

    _.map(_data, (res, i) => {
      const {
        day,
        month,
        year,
        EnergyBudgetKwh,
        EnergyConsumptionKwh,
        type: { _type },
      } = res;
      arrData.push(`${day}/${month}/${year}`);
      accumulatedEnergyBudget += EnergyBudgetKwh;
      accumulatedEnergyConsumption += EnergyConsumptionKwh;
      energyBudget.push(parseFloat(accumulatedEnergyBudget.toFixed(2)));
      energyConsumption.push(
        parseFloat(accumulatedEnergyConsumption.toFixed(2))
      );

      if (_type === 'forecast' && forecastStartIndex === 0) {
        forecastStartIndex = i;
      }
    });

    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'EnergyBudgetForecastContainer',
        type: 'line',
      },
      subtitle: {
        text: arrData.length > 0 && 'Dotted line represnts forecasted data',
      },
      xAxis: {
        type: 'category',
        categories: data.length > 0 && arrData,
        title: {
          text: 'Days',
        },
        labels: {
          rotation: 310,
        },
      },
      yAxis: [
        {
          title: {
            text: 'Energy (kWh)',
          },
        },
      ],
      series: [
        {
          name: 'Energy Budget',
          type: 'line',
          color: _.shuffle(constants.colorObj)[0],
          marker: { symbol: 'circle', radius: 2, enabled: false },
          lineWidth: 2,
          data: energyBudget,
        },
        {
          name: 'Energy Consumption',
          type: 'line',
          color: _.shuffle(constants.colorObj)[0],
          marker: { symbol: 'circle', radius: 2, enabled: false },
          lineWidth: 2,
          zoneAxis: 'x',
          zones: [
            {
              value: forecastStartIndex,
            },
            {
              dashStyle: 'dot',
            },
          ],
          data: energyConsumption,
        },
      ],
    });
    setData(chart);
    setLoading(false);
  };

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        setLoading(true);
        setData({});
        fetchEnergyBudget(type, id, interval)
          .then((response) => {
            setLoading(false);
            const { statusCode, result } = response.data;
            showData(statusCode === 200 ? result.forecastValues : []);
          })
          .catch((error) => {
            setLoading(false);
            showData([]);
            console.log(error);
          });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default React.memo(ChartEnergyBudgetForecast);
